import React, { useState } from "react";

interface NumericButtonsProps {
  onButtonClick: (val: string) => void;
}

export default function NumericButtons({ onButtonClick }: NumericButtonsProps) {
  const [pressedButton, setPressedButton] = useState<string | null>(null);

  const pad = [
    ["1", "2", "3"],
    ["4", "5", "6"],
    ["7", "8", "9"],
    ["초기화", "0", "삭제"],
  ];

  const displayMap: { [key: string]: string } = {
    "초기화": "⟲",
    "삭제": "⌫"
  };

  const handleMouseDown = (val: string) => {
    setPressedButton(val);
  };

  const handleMouseUp = () => {
    setPressedButton(null);
  };

  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: "10px",
      width: "100%",
      maxWidth: "90%",
      gridAutoRows: "70px", // 직사각형 형태로 높이를 고정
      boxSizing: "border-box",
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
    }}>
      {pad.flat().map((val) => {
        const isSpecial = val === "초기화" || val === "삭제";
        const isPressed = pressedButton === val;
        return (
          <button
            key={val}
            onClick={() => onButtonClick(val)}
            onMouseDown={() => handleMouseDown(val)}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            style={{
              width: "100%",
              height: "70px",
              fontSize: isSpecial ? "24px" : "24px",
              background: isPressed
                ? isSpecial
                  ? "#1b3fa0"
                  : "#4b5cb8"
                : isSpecial
                ? "#e9edff"
                : "#fff",
              color: isPressed
                ? "#fff"
                : isSpecial
                ? "#666"
                : "#222",
              border: isSpecial ? "1px solid #8aa0ff" : "1px solid transparent",
              borderRadius: "10px",
              fontWeight: isSpecial ? 500 : 600,
              boxShadow: isPressed
                ? isSpecial
                  ? "inset 0 4px 8px rgba(0, 0, 0, 0.3), 0 1px 2px rgba(0, 0, 0, 0.2)"
                  : "inset 0 4px 8px rgba(75, 92, 184, 0.4), 0 1px 2px rgba(0, 0, 0, 0.2)"
                : isSpecial
                ? "0 2px 8px rgba(138, 160, 255, 0.35)"
                : "0 2px 8px #eaeaea",
              outline: "none",
              cursor: "pointer",
              transition: "all 0.08s",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              letterSpacing: isSpecial ? "0.5px" : "0",
              transform: isPressed ? "scale(0.92)" : "scale(1)"
            }}>
            {val === "초기화" ? (
              <img
                src="/minimal-refresh-arrow.png"
                alt="새로고침"
                style={{
                  width: "20px",
                  height: "20px",
                  filter: isPressed ? "brightness(0) invert(1)" : "none"
                }}
              />
            ) : (
              displayMap[val] || val
            )}
          </button>
        );
      })}
    </div>
  );
}
